export default __webpack_public_path__ + "static/media/Klint.d22f24bb.png";